import api from "../_api";

const showAddressOnViaCep = async ({ commit }, param) => {
  const result = await api.showAdressOnViaCep(param);
  commit("STORE_ADDRESS_ON_VIACEP", result);
};

const showStates = async ({ commit }, param) => {
  const result = await api.showStates(param);
  commit("STORE_STATES", result);
};

const getAddressOnViacep = async ({ commit }, param) => {
  const result = await api.getAddressOnViacep(param);
  commit("STORE_GET_ADDRESS_ON_VIACEP", result);
};

export default {
  showAddressOnViaCep,
  showStates,
  getAddressOnViacep
};
